export enum LayoutName {
  NavContent = 'nav-content',
  NavSidebarContent = 'nav-sidebar-content',
}
